const failure = (error, extras = {}) => ({
  ok: false,
  error: error?.message || String(error || "The server could not complete this change."),
  code: error?.code || "account_mutation_failed",
  ...extras,
});

export const coordinateAccountMutation = async ({ command, reloadWorkspace, applyWorkspace, isCurrent = () => true }) => {
  if (typeof command !== "function" || typeof reloadWorkspace !== "function" || typeof applyWorkspace !== "function") {
    return failure("The account mutation coordinator is not configured.", { code: "not_configured" });
  }

  let result;
  const changed = () => failure("The active account changed. Review the original account before trying again.", { code: "account_changed" });
  if (!isCurrent()) return changed();
  try {
    result = await command();
  } catch (error) {
    return failure(error);
  }

  if (!result?.ok && !result?.committed) return result || failure("The server returned an invalid response.");
  if (!isCurrent()) return changed();

  let workspace = result.workspace || null;
  if (!workspace) {
    try {
      workspace = await reloadWorkspace();
    } catch (error) {
      return failure(error, {
        code: "refresh_failed",
        committed: Boolean(result?.ok || result?.committed),
      });
    }
  }

  try {
    if (!isCurrent()) return changed();
    applyWorkspace(workspace);
  } catch (error) {
    return failure(error, {
      code: "workspace_apply_failed",
      committed: true,
    });
  }

  return {
    ...result,
    ok: true,
    committed: Boolean(result.committed),
    recoveredAfterRefreshFailure: Boolean(result.committed && !result.ok),
    workspace,
  };
};
